<mat-tab-group [selectedIndex]="1">
  <mat-tab label="Создать нового">
    <form
      class="blogger-form"
      [formGroup]="bloggerFormGroup()"
    >
      @for (field of newBloggerFormFields; track $index) {
        <div class="blogger-form-container">
          <mat-form-field
            class="blogger-form-field"
            appearance="outline"
          >
            <mat-label>
              {{ field.label }}
            </mat-label>
            <input
              matInput
              [formControlName]="field.fieldName"
            >
          </mat-form-field>
        </div>
      }
      <mat-divider></mat-divider>
      <button
        mat-button
        class="blogger-form-btn"
        color="primary"
        type="submit"
        [disabled]="bloggerFormGroup().invalid"
        (click)="handleCreateNewBlogger()"
      >
        Добавить
      </button>
    </form>
  </mat-tab>
  <mat-tab label="Выбрать существующего">
    <div class="blogger-form">
      <mat-form-field
        class="blogger-form-search"
        appearance="outline"
      >
        <mat-label>Поиск блогера</mat-label>
        <input
          #searchInput
          matInput
          placeholder="Поиск по имени и url"
          [value]="searchBloggerNameOrUrl()"
          (input)="handleUpdateSearchValue($event)"
          (blur)="loadBloggers()"
          (keydown.enter)="searchInput.blur()"
        >
      </mat-form-field>
      <div class="blogger-form-list">
        <mat-selection-list
          [multiple]="false"
          (selectionChange)="handleSelectionListChange($event)"
        >
          @for (blogger of bloggers(); track $index) {
            <mat-list-option [value]="blogger">
              <app-blogger-info
                [bloggerData]="blogger"
                (handleOpenBloggerModal)="handleOpenBloggerModal(blogger)"
              />
            </mat-list-option>
          } @empty {
            <div class="blogger-form-no-result">
              Записей нет
            </div>
          }
        </mat-selection-list>
      </div>
      <mat-divider></mat-divider>
      <button
        mat-button
        class="blogger-form-btn"
        color="primary"
        [disabled]="!selectedBlogger()"
        (click)="handleSelectBlogger()"
      >
        Привязать
      </button>
    </div>
  </mat-tab>
</mat-tab-group>
